import { render, staticRenderFns } from "./CommissionHome.vue?vue&type=template&id=67748f19&scoped=true&"
import script from "./CommissionHome.vue?vue&type=script&lang=ts&"
export * from "./CommissionHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67748f19",
  null
  
)

export default component.exports